const Scl90Questions = [
  { id: "scl90Preg001", label: "Dolores de cabeza" },
  { id: "scl90Preg002", label: "Nerviosismo o agitación interior" },
  {
    id: "scl90Preg003",
    label:
      "Pensamientos, palabras o ideas no deseadas que no se te van de tu mente",
  },
  { id: "scl90Preg004", label: "Sensaciones de desmayo o mareo" },
  { id: "scl90Preg005", label: "Pérdida del deseo o del placer sexual" },
  {
    id: "scl90Preg006",
    label: "El hecho de juzgar a otras personas crítica o negativamente",
  },
  {
    id: "scl90Preg007",
    label: "La idea de que otra persona puede controlar tus pensamientos",
  },
  {
    id: "scl90Preg008",
    label:
      "La impresión de que la mayoría de tus problemas son culpa de los demás",
  },
  {
    id: "scl90Preg009",
    label: "Dificultad para recordar las cosas",
  },
  {
    id: "scl90Preg010",
    label:
      "Preocupaciones acerca del desaseo, el descuido o la desorganización",
  },
  { id: "scl90Preg011", label: "Sentirte fácilmente irritado o enfadado" },
  { id: "scl90Preg012", label: "Dolores en el corazón o en el pecho" },
  {
    id: "scl90Preg013",
    label: "Sentir miedo de los espacios abiertos o de la calle",
  },
  { id: "scl90Preg014", label: "Sentirte bajo de energías o decaído" },
  { id: "scl90Preg015", label: "Pensamientos o ideas de acabar con tu vida" },
  { id: "scl90Preg016", label: "Oír voces que otras personas no oyen" },
  { id: "scl90Preg017", label: "Temblores" },
  {
    id: "scl90Preg018",
    label: "La idea de que no te puedes fiar de la mayoría de las personas",
  },
  { id: "scl90Preg019", label: "Falta de apetito" },
  { id: "scl90Preg020", label: "Llorar fácilmente" },
  { id: "scl90Preg021", label: "Timidez o incomodidad con el sexo opuesto" },
  {
    id: "scl90Preg022",
    label: "La sensación de estar atrapado o como encerrado",
  },
  { id: "scl90Preg023", label: "Tener miedo de repente y sin razón" },
  {
    id: "scl90Preg024",
    label: "Arrebatos de cólera o ataques de furia que no logras controlar",
  },
  { id: "scl90Preg025", label: "Miedo a salir de casa solo" },
  { id: "scl90Preg026", label: "Culparte a ti mismo de lo que pasa" },
  { id: "scl90Preg027", label: "Dolores en la parte baja de la espalda" },
  { id: "scl90Preg028", label: "Sentirte incapaz de lograr cosas" },
  { id: "scl90Preg029", label: "Sentirte solo" },
  { id: "scl90Preg030", label: "Sentirte triste" },
  { id: "scl90Preg031", label: "Preocuparte demasiado por las cosa" },
  { id: "scl90Preg032", label: "No sentir interés por las cosas" },
  { id: "scl90Preg033", label: "Sentirte temeroso" },
  {
    id: "scl90Preg034",
    label: "Ser demasiado sensible o sentirte herido con facilidad",
  },
  {
    id: "scl90Preg035",
    label: "La impresión de que los demás se dan cuenta de tus pensamientos",
  },
  {
    id: "scl90Preg036",
    label:
      "La sensación de que los demás no te comprenden o no te hacen caso",
  },
  {
    id: "scl90Preg037",
    label:
      "La impresión de que la gente es poco amistosa o que tu no les gustas",
  },
  {
    id: "scl90Preg038",
    label:
      "Tener que hacer las cosas muy despacio para estar seguro de que las haces bien",
  },
  {
    id: "scl90Preg039",
    label: "Que el corazón te palpita o te vaya muy deprisa",
  },
  { id: "scl90Preg040", label: "Náuseas o malestar en el estómago" },
  { id: "scl90Preg041", label: "Sentirte inferior a los demás" },
  { id: "scl90Preg042", label: "Dolores musculares" },
  {
    id: "scl90Preg043",
    label: "Sensación de que otras personas te miran o hablan de ti",
  },
  { id: "scl90Preg044", label: "Dificultad para conciliar el sueño" },
  {
    id: "scl90Preg045",
    label: "Tener que comprobar una y otra vez lo que haces",
  },
  { id: "scl90Preg046", label: "Encontrar difícil el tomar decisiones" },
  {
    id: "scl90Preg047",
    label: "Sentir temor a viajar en coches, autobuses, metro, trenes, etc.",
  },
  { id: "scl90Preg048", label: "Dificultad para respirar" },
  { id: "scl90Preg049", label: "Sentir calor o frío de repente" },
  {
    id: "scl90Preg050",
    label:
      "Tener que evitar ciertas cosas, lugares o actividades por que te dan miedo",
  },
  { id: "scl90Preg051", label: "Que se te quede la mente en blanco" },
  {
    id: "scl90Preg052",
    label: "Entumecimiento u hormigueo en alguna parte del cuerpo",
  },
  { id: "scl90Preg053", label: "Sentir un nudo en la garganta" },
  {
    id: "scl90Preg054",
    label: "Sentirte desesperanzado con respecto al futuro",
  },
  { id: "scl90Preg055", label: "Tener dificultad para concentrarte" },
  { id: "scl90Preg056", label: "Sentirte débil en alguna parte del cuerpo" },
  { id: "scl90Preg057", label: "Sentirte tenso o agitado" },
  { id: "scl90Preg058", label: "Pesadez en los brazos o las piernas" },
  {
    id: "scl90Preg059",
    label: "Pensamientos sobre la muerte o el hecho de morir",
  },
  { id: "scl90Preg060", label: "El comer demasiado" },
  {
    id: "scl90Preg061",
    label:
      "Sentirte incomodo cuando la gente te mira o habla acerca de ti",
  },
  { id: "scl90Preg062", label: "Tener pensamientos que no son tuyos" },
  {
    id: "scl90Preg063",
    label: "Sentir el impulso de golpear, herir o hacer daño a alguien",
  },
  { id: "scl90Preg064", label: "Despertarte de madrugada" },
  {
    id: "scl90Preg065",
    label:
      "Tener que repetir las mismas acciones tales como tocar, contar, lavar, etc.",
  },
  { id: "scl90Preg066", label: "Sueño inquieto o desvelarte fácilmente" },
  { id: "scl90Preg067", label: "Tener fuertes deseos de romper algo" },
  {
    id: "scl90Preg068",
    label: "Tener ideas o creencias que los demás no comparten",
  },
  { id: "scl90Preg069", label: "Sentirte muy cohibido entre otras personas" },
  {
    id: "scl90Preg070",
    label:
      "Sentirte muy incómodo entre mucha gente, p.ej. en el cine, en las tiendas",
  },
  { id: "scl90Preg071", label: "Sentir que todo requiere un gran esfuerzo" },
  { id: "scl90Preg072", label: "Ataques de terror o pánico" },
  {
    id: "scl90Preg073",
    label: "Sentirte incómodo comiendo o bebiendo en público",
  },
  { id: "scl90Preg074", label: "Tener discusiones frecuentes" },
  { id: "scl90Preg075", label: "Sentirte nervioso cuando te encuentras solo" },
  {
    id: "scl90Preg076",
    label: "El que otros no reconozcan adecuadamente tus logros",
  },
  { id: "scl90Preg077", label: "Sentirte solo aunque esté con más gente" },
  {
    id: "scl90Preg078",
    label: "Sentirte tan inquieto que no puedes ni estar sentado tranquilo",
  },
  {
    id: "scl90Preg079",
    label: "La sensación de ser inútil o de no valer nada",
  },
  { id: "scl90Preg080", label: "Pensamientos de que va a pasar algo malo" },
  { id: "scl90Preg081", label: "Tener deseos de gritar o de tirar cosas" },
  { id: "scl90Preg082", label: "Tener miedo de desmayarte en público" },
  {
    id: "scl90Preg083",
    label:
      "La impresión de que la gente intentaría aprovecharse de ti si les dejaras",
  },
  {
    id: "scl90Preg084",
    label: "Tener pensamientos sobre el sexo que te inquietan bastante",
  },
  {
    id: "scl90Preg085",
    label: "La idea de que deberías ser castigado por tus pecados",
  },
  {
    id: "scl90Preg086",
    label: "Pensamientos o imágenes estremecedoras que te dan miedo",
  },
  { id: "scl90Preg087", label: "La idea de que algo anda mal en tu cuerpo" },
  { id: "scl90Preg088", label: "No sentirte cercano o íntimo con nadie" },
  { id: "scl90Preg089", label: "Sentimientos de culpabilidad" },
  {
    id: "scl90Preg090",
    label: "La idea de que algo anda mal en tu mente",
  },
];

export default Scl90Questions;
